module.exports = __webpack_public_path__ + "img/12.ae8be091.png";